import { CSSProperties } from "react"
import Icon from "src/shared/icons"
import cx from "classnames"
import "./AlertSuscripcioon.css"

function AlertSuscripcion({className = "", style = {}, fecha = "" }: {className?: string, style?: CSSProperties, fecha: string }) {
    return (
        <div className={cx("alert-suscripcion", className)} style={style}>
            <div className="alert-suscripcion__head">
                <Icon height={12} width={12} name={"alertFill"} color={"var(--ocupado)"} />
                <p className="alert-suscripcion__title">{"Pago de suscripción pendiente"}</p>
            </div>
            <p className="alert-suscripcion__description">
                {"Actualiza tu datos de pago antes del "}
                <span>{fecha}</span>
                {" para seguir disfrutando de Easyroom."}
            </p>
        </div>
    )
}

export default AlertSuscripcion